//For handling newsletter subscriptions
(function () {
    let postData, customerEmail, apiUrl, customerEmailInput, btnSubmit, successMessage;

    function newsletterSubscriptionInit(){
        customerEmailInput = document.getElementById("newsletter_customer_email");
        btnSubmit = document.getElementById("newsletter_submit");
        successMessage = customerEmailInput.getAttribute("data-success-message");
        apiUrl ='https://suomalainen-atp.aste.dev/api/newsletter/subscribe';

        //Submit button event listener
        btnSubmit.addEventListener("click", function(event){        
            event.preventDefault();
            btnSubmit.disabled = true;
            removeErrorMessages();
            customerEmail = customerEmailInput.value;
            if(customerEmail == '') {
                //error, empty input
                document.getElementById("newsletter_missing_required_fields").classList.remove('hidden');
                btnSubmit.disabled = false;
            } else {
                postData = {           
                    email: customerEmail            
                };
                sendNewsletterSubscription(postData);
            }
        });
    }    

    //For removing error messages from screen
    function removeErrorMessages(){
        document.querySelectorAll('.newsletter-errors').forEach(el => el.classList.add('hidden'));
    };

    //API request
    function sendNewsletterSubscription( requestData ) {
        var request = new XMLHttpRequest();
        var url = apiUrl;
        request.open('POST', url);
        request.onload = function() {
            var res = JSON.parse(this.response);
            if (res.response_type === 'newsletter_subscribe_success') {
                btnSubmit.remove();
                customerEmailInput.value = "";
                customerEmailInput.classList.add("input-success");
                customerEmailInput.placeholder = successMessage;
            } else {
                if (res.response_type === 'invalid_format') {
                    document.getElementById("newsletter_invalid_format").classList.remove('hidden');
                } else if (res.response_type === 'missing_required_fields') {
                    document.getElementById("newsletter_missing_required_fields").classList.remove('hidden');
                } else {
                    document.getElementById("newsletter_generic_error").classList.remove('hidden');
                }
                btnSubmit.disabled = false;
            }
        };
        request.onerror = function() {
            document.getElementById("newsletter_generic_error").classList.remove('hidden');
            btnSubmit.disabled = false;
        };
        var requestObj = {data: requestData};
        var postData = JSON.stringify(requestObj);
        request.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        request.send(postData);
    };

    if (document.readyState === "complete" || document.readyState === "loaded") {
        newsletterSubscriptionInit();
    } else {
        document.addEventListener("DOMContentLoaded", newsletterSubscriptionInit);
    }
})();